import { Component, OnInit,HostListener, ViewChild } from '@angular/core';
import { Globals } from '../../../../../shared/models/Globals';
import { Input } from '@angular/core';
declare var $: any;

@Component({
  selector: 'eshop-inner-product-listing',
  templateUrl: './eshop-inner-product-listing.component.html',
  styleUrls: []
})

export class EshopInnerProductListingComponent implements OnInit {
  globals;
  rtl = Globals.Culture == "ar";


  slideConfig = {
    "infinite": true,
    "slidesToShow": 5,
    "slidesToScroll": 1,
    "arrows": true,
    "touchThreshold": 3,
    "center": false,
    "rtl": this.rtl,
    "responsive": [
      {
        "breakpoint": 1366,
        "settings": {
          "slidesToShow": 4,
        }
      },
      {
        "breakpoint": 1025,
        "settings": {
          "slidesToShow": 3,
        }
      },
      {
        "breakpoint": 825,
        "settings": {
          "infinite": false,
          "arrows": false,
          "slidesToShow": 2,
        }
      },
      {
        "breakpoint": 480,
        "settings": {
          "slidesToShow": 1,
          "arrows": false
        }
      }
    ]
  };


  _listTitle;
  get listTitle(): any { 
    return this._listTitle;
  }
  @Input()
  set listTitle(val: any) {
    this._listTitle = val;
  }



  _productsList; 
  get productsList(): any { 
    return this._productsList;
  }
  @Input()
  set productsList(val: any) {
    this._productsList = val;
  }


  constructor() 
  { 
    this.globals = Globals;
  }

  ngOnInit() {
  }

}
